import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { useSpring, animated } from "react-spring"
import { Waypoint } from "react-waypoint"
import CustomImage from "@/main/customImage"
import { Col, Card, Button } from "react-bootstrap"

import {
    toggleGetInTouchModal,
    setGetInTouchRecipient,
} from "@/slices/getInTouchModalSlice"

function EmployeeCard(props) {
    const dispatch = useDispatch()

    const [inView, setInView] = useState(false)

    const fadeRight = useSpring({
        delay: 500,
        to: {
            opacity: inView ? 1 : 0,
            marginLeft: inView ? 0 : 300,
        },
    })

    const fadeLeft = useSpring({
        delay: 500,
        to: {
            opacity: inView ? 1 : 0,
            marginRight: inView ? 0 : 300,
        },
    })

    return (
        <Col
            xs={12}
            md={6}
            className={
                props.name === "Steve Webb"
                    ? "p-0 mb-4"
                    : props.name === "Mark Jenkins"
                      ? "p-0 mb-4"
                      : props.name === "Beckie Aubert"
                        ? "p-0"
                        : "p-0 mb-4 mb-md-0 mx-auto"
            }
        >
            <Waypoint onEnter={() => setInView(true)}>
                <animated.div
                    className="h-100"
                    style={props.direction === "right" ? fadeRight : fadeLeft}
                >
                    <Card
                        className={
                            props.name === "Steve Webb"
                                ? "h-100 me-md-3 p-0"
                                : props.name === "Mark Jenkins"
                                  ? "h-100 ms-md-3 p-0 "
                                  : props.name === "Beckie Aubert"
                                    ? "h-100 ms-md-3 p-0 "
                                    : "h-100 me-md-3 mb-md-0 p-0 "
                        }
                    >
                        <div className="employee-img-div">
                            <CustomImage
                                src={`https://webb-jenkins-static-164679926.imgix.net/employees/${props.image}`}
                                alt={props.alt}
                                layout="fill"
                                objectFit="cover"
                                objectPosition="center"
                                sizes="50vw"
                            />
                        </div>

                        <Card.Body>
                            <Card.Title>
                                <h3>{props.name}</h3>
                                <p className="text-lg text-semi-bold">
                                    {props.name === "Steve Webb" ||
                                    props.name === "Mark Jenkins"
                                        ? "Director"
                                        : "Administrator"}
                                </p>
                            </Card.Title>
                            <Card.Text>
                                <span>
                                    {props.name === "Steve Webb"
                                        ? "Steve established the business in 1998 having moved across from a career in corporate estate agency, managing several branches across the Island over a period of years. Living and being brought up locally, Steve has gained a wealth of local knowledge and contacts to enable the business to thrive by helping buyers, sellers, tenants and landlords."
                                        : props.name === "Mark Jenkins"
                                          ? "Mark is a joint director of Webb Jenkins and has 30 years’ experience in the estate agency industry. He began his career working for a large corporate company where he ran a busy and profitable office, before joining Steve Webb to form a new partnership as Webb Jenkins."
                                          : props.name === "Olivia Jenkins"
                                            ? "Olivia started her career with Webb Jenkins a number of years ago and has become an invaluable member of the team, handling both the letting and sales aspects of the business. She has become very popular with vendors, landlords and tenants with her nothing is too much trouble attitude."
                                            : "Having worked in the property sales and letting industry for many years, for various agents across the Island, Beckie’s addition to our team 5 years ago has proved invaluable. The lettings department here at Webb Jenkins has gone from strength to strength under her stewardship."}
                                </span>
                            </Card.Text>
                        </Card.Body>
                        <Card.Footer>
                            <Button
                                variant={
                                    props.name === "Steve Webb" ||
                                    props.name === "Beckie Aubert"
                                        ? "warning"
                                        : "outline-warning"
                                }
                                onClick={() => {
                                    dispatch(toggleGetInTouchModal(true))
                                    dispatch(
                                        setGetInTouchRecipient(
                                            props.name.split(" ")[0],
                                        ),
                                    )
                                }}
                                className="mt-auto rounded-0"
                            >
                                <span
                                    className={
                                        props.name === "Steve Webb" ||
                                        props.name === "Beckie Aubert"
                                            ? "text-white text-bold"
                                            : "text-wjorange text-bold"
                                    }
                                >
                                    {"Contact " + props.name.split(" ")[0]}
                                </span>
                            </Button>
                        </Card.Footer>
                    </Card>
                </animated.div>
            </Waypoint>
        </Col>
    )
}

export default EmployeeCard
